import * as React from 'react';
import { ContainerComponentProps } from 'types';
import { ComponentData } from './config';
import Image from './Image';
import './index.scss';

function Container({ children, data, commonStyle }: ContainerComponentProps<ComponentData>) {
  return (
    <div className="container" style={commonStyle}>
      <Image data={data} />
      {children}
    </div>
  );
}

export default Container;
